var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "splash-page" },
    [
      _c("v-card", { staticClass: "card-spinner" }, [
        _c(
          "div",
          {
            staticClass:
              "header navy darken-2 secondary--text pb-10 d-flex flex-column align-center",
          },
          [
            _c("img", {
              staticClass: "logo",
              attrs: { src: _vm.firebase_host + "/static/img/logo_ombra.png" },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", [
          _c("img", {
            staticClass: "spinner",
            attrs: { src: _vm.firebase_host + "/static/gif/lab.gif" },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "dai-lab d-flex align-center justify-center flex-column mb-5 font-hemi-head",
            },
            [
              _c(
                "div",
                { staticClass: "d-flex align-center" },
                [
                  _vm._v("\n          Con\n          "),
                  _c("v-icon", { staticClass: "cuore ml-1 error--text" }, [
                    _vm._v("favorite"),
                  ]),
                  _vm._v("\n          dai laboratori di\n        "),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _c("a", { attrs: { href: _vm.host, target: "_blank" } }, [
                  _vm._v("fantapazz.com"),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }